import React from 'react';
import Field from '../../../../../../../../../../../../BaseComponents/Forms/EDField';
import EDStandardSelect from '../../../../../../../../../../../../BaseComponents/Selects/StandardSelect/EDStandardSelect';

interface IProps {}

export interface IColumnType {
  id: number;
  displayLabel: string;
}

const values: IColumnType[] = [
  { id: 0, displayLabel: 'Saldo' },
  { id: 1, displayLabel: 'Debet' },
  { id: 2, displayLabel: 'Kredit' },
  { id: 3, displayLabel: 'Antal' },
];

class EkonomiskAnalysEditColumnTypeField extends React.Component<IProps> {
  render() {
    return (
      <Field name="columnType">
        {({ value, onChange }) => (
          <EDStandardSelect
            label="Kolumntyp"
            value={value || 0}
            onChange={onChange}
            items={values.map(value => ({
              header: value.displayLabel,
              value: value.id,
            }))}
            fullWidth
            tooltip="Kolumntyp"
          />
        )}
      </Field>
    );
  }
}

export default EkonomiskAnalysEditColumnTypeField;
